"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCSSAssets = exports.loadAssets = exports.loadLibraryAssets = void 0;
var flags_1 = require("../flags");
var assets_1 = require("../toolbox/assets");
function isCSSAssetLoaded(url) {
    return (
    // pre fetched (inlined) style tag
    document.querySelector("style[data-href=\"" + url + "\"]") !== null ||
        // normal CSS import
        document.querySelector("link[href=\"" + url + "\"]"));
}
function injectStyleTag(url) {
    return new Promise(function (resolve, reject) {
        var style = document.createElement('link');
        style.setAttribute('rel', 'stylesheet');
        style.setAttribute('type', 'text/css');
        style.setAttribute('href', url);
        style.addEventListener('load', function () { return resolve(url); });
        style.addEventListener('error', function (e) { return reject(e); });
        document.head.appendChild(style);
    });
}
function loadLibraryAssets(assets) {
    loadAssets(assets);
}
exports.loadLibraryAssets = loadLibraryAssets;
function loadAssets(assets) {
    var styleAssets = assets_1.filterStyleAssets(assets);
    return loadCSSAssets(__spreadArrays(styleAssets.filter(function (asset) { return !!asset.dependency; }), styleAssets.filter(function (asset) { return !asset.dependency; })));
}
exports.loadAssets = loadAssets;
function loadCSSAssets(assets) {
    if (flags_1.isServer) {
        return Promise.resolve();
    }
    return Promise.all(assets
        .filter(function (_a) {
        var url = _a.url;
        return !isCSSAssetLoaded(url);
    })
        .map(function (_a) {
        var url = _a.url;
        return injectStyleTag(url);
    }));
}
exports.loadCSSAssets = loadCSSAssets;
//# sourceMappingURL=loadAssets.js.map